module.exports = __webpack_public_path__ + "static/media/Rubik-BoldItalic.5d0336e2.ttf";